import React, { useEffect, useState } from "react";
import { Autocomplete, TextField, Typography } from "@mui/material";

const CustomSelectBox = ({ options, value, onChange, label }) => {
    const [selectedValue, setSelectedValue] = useState(value || options[0]?.value);

    useEffect(() => {
        onChange(selectedValue); // Set default selection on mount
    }, [selectedValue, onChange]);

    return (
        <Autocomplete
            options={options}
            getOptionLabel={(option) => option.label} // Display label in dropdown
            value={options.find((option) => option.value === selectedValue) || null}
            onChange={(event, newValue) => {
                setSelectedValue(newValue ? newValue.value : options[0]?.value);
                onChange(newValue ? newValue.value : options[0]?.value);
            }}
            slotProps={{
                listbox: {
                    style: {
                        padding: 0,
                        borderRadius:"0 !important"
                    },
                },
            }}
            renderOption={(props, option, { selected }) => (
                <li
                    {...props}
                    key={option.value}
                    style={{
                        border: "1px solid #DC143C"
                        
                    }}
                >
                    <Typography variant="body2">{option.label}</Typography>
                </li>
            )}
            sx={{
                "& .MuiAutocomplete-option:hover": {
                    backgroundColor: "#f5f5f5",
                },
                "& .MuiOutlinedInput-root .MuiSvgIcon-root": {
                    color: "#fff !important", // Set dropdown icon color to white
                },
                "& .MuiInputBase-input": {
                    color: "#fff !important", // Ensures input text color is white
                },
                "& .MuiAutocomplete-input": {
                    color: "#fff !important", // Ensures autocomplete text color is white
                },
                bgcolor: "#DC143C",
                borderRadius: "6px",
                "& fieldset": { border: "none" },
                "& .MuiOutlinedInput-root .MuiAutocomplete-input": { padding: "1px 0" }
            }}
            renderInput={(params) => (
                <TextField
                    {...params}
                    label={label}
                />
            )}
            fullWidth
        />
    );
};

export default CustomSelectBox;
